import { render, staticRenderFns } from "./CampaignList.vue?vue&type=template&id=f536ef02"
import script from "./CampaignList.vue?vue&type=script&lang=js"
export * from "./CampaignList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports